import { Component, OnInit, Optional, Inject } from '@angular/core';
import { SsrsReportsService } from '@shared/services/SSRSreports/ssrsReports.service';
import { LibranzaReportsService } from '../services/libranza-reports.service';
import { ReportingFilterComponent } from '@shared/components/reports/reporting-filter/reporting-filter.component';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { LoadingService } from '@shared/utils/loading.service';
import { SwalService } from '@shared/utils/swal.service';
import { Reportes } from '@pages/cobranza/interfaces/reportes';

interface IReporte {
  clave: string;
  descripcion: string;
  tablaPivote: string;
}

@Component({
  selector: 'app-reportes-libranzas',
  templateUrl: './reportes-libranzas.component.html'
})
export class ReportesLibranzasComponent implements OnInit {
  public reportes: IReporte[] = [];
  typeFile: 'CSV' | 'PDF' = 'CSV';

  constructor(
    private ssrsReports: SsrsReportsService,
    private libranzaReports: LibranzaReportsService,
    public dialog: MatDialog,
    public loading: LoadingService,
    private _swalService: SwalService,
    @Optional() public dialogRef: MatDialogRef<ReportesLibranzasComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  ngOnInit(): void {
    console.log('Datos recibidos:', this.data);
    // Si se pasa un reporte específico, ir directamente a ese reporte
    if (this.data?.reportId) {
      this.generateSpecificReport(this.data.reportId, this.data.reportName);
    }
  }

  // Método para generar reporte específico directamente
  generateSpecificReport(reportId: string, reportName: string): void {
    console.log('Generando reporte específico:', reportId, reportName);
    
    // Primero obtenemos la lista de reportes con módulo 90 para obtener datos completos
    this.getReportsWithModule90(reportId, reportName);
  }

  // Método para obtener reportes con módulo 90
  getReportsWithModule90(reportId: string, reportName: string): void {
    this.loading.show();
    
    const model: Reportes = {
      Que: 7,
      Tope: '100',
      Cmd: '',
      SCmd: '',
      Clave: '',
      Descripcion: '',
      TablaPivote: '',
      XmL_File: '',
      HtmL_File: '',
      XmL_Dat: '',
      Usuario: 'ADMLGB',
      Catalogo: '',
      Master: '',
      TipoCampos: '',
      Modulo: '90', // Módulo específico para libranzas
      Separador: ''
    };

    this.libranzaReports.getAllReports(model).subscribe({
      next: (res: any) => {
        console.log('Respuesta getReports módulo 90:', res);
        if (Array.isArray(res)) {
          this.reportes = res.map((item) => ({
            clave: item.clave || '',
            descripcion: item.descripcion || '',
            tablaPivote: item.tablaPivote || ''
          }));
          
          // Buscar el reporte específico por su clave
          const foundReport = this.reportes.find(report => report.clave === reportId);
          
          if (foundReport) {
            console.log('Reporte encontrado:', foundReport);
            this.loading.hide();
            this.getConfReport(foundReport.clave, foundReport.descripcion, foundReport.tablaPivote);
          } else {
            console.log('Reporte no encontrado en módulo 90, usando datos básicos');
            this.loading.hide();
            this.getConfReport(reportId, reportName);
          }
        } else {
          console.log('Sin respuesta de getReports, usando datos básicos');
          this.loading.hide();
          this.getConfReport(reportId, reportName);
        }
      },
      error: (error) => {
        console.error('Error al cargar reportes:', error);
        this.loading.hide();
        this.getConfReport(reportId, reportName);
      }
    });
  }

  getConfReport(reportId: string, reportName?: string, tablaPivote?: string): void {
    // Lógica idéntica a reportes-plan-pagos
    if (tablaPivote && tablaPivote.includes('RSO')) {
      this.typeFile = 'PDF';
    } else if (tablaPivote && tablaPivote.includes('PROCEDURE')) {
      this.typeFile = 'CSV';
    } else {
      this.typeFile = 'CSV'; // Default a CSV si no se puede determinar
    }
    this.loading.show();
    this.ssrsReports.GetConfReport(reportId).subscribe({
      next: (res) => {
        if (res.success && res.data.filterList === null) {
          this.loading.hide();
          console.log(res);
          const dialogRef = this.dialog.open(ReportingFilterComponent, {
            data: {
              report: res.data,
              reportId: reportId,
              reportName: reportName,
              typeFile: this.typeFile,
              direct: true
            }
          });
          dialogRef.afterClosed().subscribe((confirmresult) => {
            this.Close();
          });
        } else if (res.success) {
          this.loading.hide();
          console.log(res);
          const dialogRef = this.dialog.open(ReportingFilterComponent, {
            data: {
              report: res.data,
              reportId: reportId,
              reportName: reportName,
              typeFile: this.typeFile,
              direct: false
            }
          });
          dialogRef.afterClosed().subscribe((confirmresult) => {
            this.Close();
          });
        } else {
          this.loading.hide();
          console.log(res);
          this._swalService.error('Ocurrio un error al traer la configuracion del reporte.');
        }
      },
      error: (err) => {
        this.loading.hide();
        console.log(err);
        this._swalService.error('Error al obtener la configuración del reporte.');
      }
    });
  }


  // Método para cerrar el diálogo
  Close(): void {
    if (this.data?.onClose) {
      this.data.onClose();
    }

    if (this.dialogRef) {
      this.dialogRef.close();
    }
  }
}